<template>
  <Background :bgColor="bgColor">
    <Container>
      <div class="space-y-20px lg:space-y-40px">
        <Title
          v-if="data.title"
          :headingTag="data.titleHeaderTag"
          :style="data.titleHeaderTag">
          {{ data.title }}
        </Title>
        <Paragraphs v-html="data.body"> </Paragraphs>
        <TextImageItem
          v-for="(item, key) in data.imageList"
          :key="key"
          :headingTag="item.titleHeadingTag"
          :headingStyle="item.titleHeadingTag"
          :image="item.image.image"
          :body="item.body">
          <template #title>{{ item.title }}</template>
        </TextImageItem>
      </div>
    </Container>
  </Background>
</template>

<script>
import Background from "../Atoms/Background.vue";
import Container from "../Atoms/Container.vue";
import Paragraphs from "../Atoms/ParagraphsNew.vue";
import Title from "../Atoms/Heading.vue";

import useHasSlot from "../../compostables/useHasSlot";
import TextImageItem from "../Modules/TextImageItem.vue";

export default {
  components: {
    Background,
    Container,
    Paragraphs,
    Title,
    TextImageItem,
  },

  props: {
    data: {
      type: Object,
      required: true,
    },
  },

  setup(props, { slots }) {
    const { hasSlot } = useHasSlot(slots);
    let bgColor = "white";

    // if (props.data.backgroundColor) {
    //   bgColor = props.data.backgroundColor;
    // }

    return {
      bgColor,
      hasSlot,
    };
  },
};
</script>
